import { useEffect } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { CHECK_ZOOM } from "./exhibition-location-map-const";


export const MapViewController = ({ center, zoom }) => {
    const map = useMap();

    useEffect(() => {
        map.setView(center, zoom);
        window.setTimeout(() => map.invalidateSize(), 0);
    }, [ map, center, zoom ]);

    return null;
};

export const MapSearchController = ({ target }) => {
    const map = useMap();

    useEffect(() => {
        if (!target)
        {
            return;
        }

        if (target.bounds?.length)
        {
            map.fitBounds(L.latLngBounds(target.bounds), { padding: [ 30, 30 ] });
        }
        else if (target.center)
        {
            map.setView(target.center, target.zoom || CHECK_ZOOM);
        }

        window.setTimeout(() => map.invalidateSize(), 0);
    }, [ map, target ]);

    return null;
};

export const MapClickHandler = ({ onMapClick }) => {
    useMapEvents({
        click: onMapClick,
    });

    return null;
};
